import { Button, Drawer, Input, Space, Table, Form } from "antd";
import { useContext, useEffect, useState } from "react";

import { ExportToExcel } from "../../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import Moment from "react-moment";
import { ColumnsType } from "antd/es/table";
import { AuthContext } from "../../../contexts/AuthContext";
import { Download, Funnel, Users, X } from "lucide-react";
import { handleFetchAutoRequests } from "../../../api/autorequests";
import { DeleteOutlined, EyeFilled } from "@ant-design/icons";
import UpdateApprover from "./UpdateApprover";
import MoveToExecutor from "./MoveToExecutor";
import UpdateExecutor from "./UpdateExecutor";
import DeleteRequest from "./DeleteRequest";
import CompleteRequest from "./CompleteRequest";
import UpdateBusiness from "./UpdateBusiness";
import UpdateRequester from "./UpdateRequester";
import RequestDetails from "./RequestDetails";
import ApproveRequest from "./ApproveRequest";
import UpdateApprovedDate from "./UpdateApprovedDate";
const { Search } = Input;

export default function AllAutoRequestsDrawer({
  title = "All Requests",
  status,
  isVisible,
  setVisible,
  businessUnitId = "",
  designation = "",
  startDate = "",
  endDate = "",
}: any) {
  const { user } = useContext(AuthContext);
  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const [requesterModal, setRequesterModal] = useState<boolean>(false);
  const [approverModal, setApproverModal] = useState<boolean>(false);
  const [executorModal, setExecutorModal] = useState<boolean>(false);
  const [unitModal, setUnitModal] = useState<boolean>(false);
  const [moveToExecutorModal, setMoveToExecutorModal] =
    useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [approveModal, setApproveModal] = useState<boolean>(false);
  const [completeModal, setCompleteModal] = useState<boolean>(false);
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [approvedDateModal, setApprovedDateModal] = useState<boolean>(false);
  const [selected, setSelected] = useState<any>(null);
  const access = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  const adminAccess = [9];

  const params = `name=${search}&businessUnitId=${businessUnitId}&designation=${designation}&startDate=${startDate}&endDate=${endDate}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: requests,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["requests", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchAutoRequests({
        page: pagination.page,
        limit: pagination.limit,
        status: status || "",
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 40,
        fixed: "left",
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
      },
      {
        title: "REQUESTED FOR",
        width: 200,
        fixed: "left",
        render: (record: any) => {
          return <div className="text-black">{record?.name || "-"}</div>;
        },
      },
      {
        title: "FOR ROLE",
        width: 140,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">{record?.designation || "-"}</div>
            </div>
          );
        },
      },

      {
        title: "REQUESTED BY",
        width: 200,
        render: (record: any) => {
          return (
            <button
              onClick={() => {
                setSelected(record);
                setRequesterModal(true);
              }}
              className="text-black"
            >
              {record?.requestedBy?.name || (
                <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                  + Assign
                </button>
              )}
            </button>
          );
        },
      },
      {
        title: "REQUESTED AT",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.createdAt ? (
              <Moment format="DD/MM/YYYY">{record?.createdAt}</Moment>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        title: "APPROVER",
        width: 250,
        render: (record: any) => (
          <div className="flex items-center gap-2">
            <button
              onClick={() => {
                setSelected(record);
                setApproverModal(true);
              }}
              className="text-black"
            >
              {record?.approvedBy?.name || (
                <div className="">
                  {adminAccess.includes(user?.accessLevel) && (
                    <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                      + Assign
                    </button>
                  )}
                </div>
              )}
            </button>
            <span
              className={`${
                record?.approvalStatus === "Approved"
                  ? "text-green-600"
                  : "text-red-600"
              }`}
            >
              ({record?.approvalStatus})
            </span>
          </div>
        ),
      },
      {
        title: "APPROVED AT",
        width: 140,
        render: (record: any) => (
          <button
            onClick={() => {
              setSelected(record);
              setApprovedDateModal(true);
            }}
            className="text-black"
          >
            {record?.dateApproved ? (
              <Moment format="DD/MM/YYYY">{record?.dateApproved}</Moment>
            ) : (
              "-"
            )}
          </button>
        ),
      },
      {
        title: "EXECUTED BY",
        width: 200,
        render: (record: any) => (
          <button
            onClick={() => {
              if (adminAccess.includes(user?.accessLevel)) {
                setSelected(record);
                setExecutorModal(true);
              }
            }}
            className="text-black"
          >
            {record?.executedBy?.name || (
              <button className="border px-2 py-1 bg-gray-100 shadow-sm">
                + Assign
              </button>
            )}
          </button>
        ),
      },
      {
        title: "EXECUTED AT",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.dateExecuted ? (
              <Moment format="DD/MM/YYYY">{record?.dateExecuted}</Moment>
            ) : (
              "-"
            )}
          </span>
        ),
      },
      {
        title: "STATUS",
        width: 250,
        render: (record: any) => (
          <span
            className={`text-gray-700 ${
              record?.isCompleted && "text-green-600"
            }`}
          >
            {record?.status || "-"}
          </span>
        ),
      },

      {
        title: "ACTIONS",
        width: 180,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-end">
            {!record?.isCompleted && record?.isApproved && (
              <button
                onClick={() => {
                  if (adminAccess.includes(user?.accessLevel)) {
                    setSelected(record);
                    setCompleteModal(true);
                  }
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm hover:bg-green-100 hover:text-green-800"
              >
                Complete
              </button>
            )}

            {record?.approvalStatus === "Pending" &&
              record?.approvedBy?.email === user?.email && (
                <button
                  onClick={() => {
                    setSelected(record);
                    setApproveModal(true);
                  }}
                  className="border px-2 py-1 bg-gray-100 shadow-sm"
                >
                  Approve
                </button>
              )}

            <button
              onClick={() => {
                setSelected(record);
                setUnitModal(true);
              }}
              className={`border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm ${
                record?.businessUnit ? "bg-green-50 text-green-800" : ""
              }`}
            >
              <Users size={15} />
              <span className="mx-1">B.U</span>
            </button>

            <button
              onClick={() => {
                if (adminAccess.includes(user?.accessLevel)) {
                  setSelected(record);
                  setDeleteModal(true);
                }
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm"
            >
              <DeleteOutlined />
            </button>
          </div>
        ),
      },
      {
        title: "DETAILS",
        width: 80,
        align: "center",
        fixed: "right",
        render: (record: any) => (
          <div className="flex justify-end">
            <button
              onClick={() => {
                setSelected(record);
                setDetailsModal(true);
              }}
              className="border py-1 px-2 mx-1 flex items-center bg-blue-50 text-blue-800 shadow-sm"
            >
              <EyeFilled /> <span className="mx-1">Details</span>
            </button>
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTIONS") {
        return adminAccess.includes(user?.accessLevel);
      }
      return true;
    });
  };
  const columns = getColumns(user, access);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  useEffect(() => {
    setPagination({ ...pagination, total: requests?.total });
  }, [requests]);

  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-xxs uppercase">{title}</span>
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space>
          <Button type="default" onClick={() => setVisible(!isVisible)} danger>
            <X size={16} />
          </Button>
        </Space>
      }
    >
      <div className="">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4 bg-white">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search name"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <Funnel size={16} />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <Download size={16} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    requests?.records?.map((item: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        "Requested For": item?.name || "-",
                        User: item?.isNewUser ? "New" : "Existing",
                        Email: item?.email || "-",
                        Mobile: item?.mobile || "-",
                        "For Role": item?.designation || "-",
                        Companies: item?.companies
                          ?.map((company: any) => company)
                          .join(", "),
                        Levels: item?.levels
                          ?.map((level: any) => level)
                          .join(", "),
                        "Requested By": item?.requestedBy?.name || "-",
                        "Requested At": (
                          <Moment format="DD/MM/YYYY">{item?.createdAt}</Moment>
                        ),
                        "Approved By": item?.approvedBy?.name || "-",
                        "Approved At": (
                          <Moment format="DD/MM/YYYY">
                            {item?.dateApproved}
                          </Moment>
                        ),
                        "Executed By": item?.executedBy?.name || "-",
                        "Executed At": (
                          <Moment format="DD/MM/YYYY">
                            {item?.dateExecuted}
                          </Moment>
                        ),
                        Status: item?.status || "-",
                        Completed: item?.isCompleted ? "Yes" : "No",
                      };
                    }),
                    `RequestsByUnit.xlsx`
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="shadow-sm">
            <Table
              size="small"
              dataSource={requests?.records}
              columns={columns}
              scroll={{ y: 700, x: "max-content" }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              rowClassName={"hover:bg-gray-100 cursor-pointer"}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>

      {requesterModal && (
        <UpdateRequester
          isVisible={requesterModal}
          setVisible={setRequesterModal}
          selected={selected || {}}
        />
      )}

      {approverModal && (
        <UpdateApprover
          isVisible={approverModal}
          setVisible={setApproverModal}
          selected={selected || {}}
        />
      )}
      {approvedDateModal && (
        <UpdateApprovedDate
          isVisible={approvedDateModal}
          setVisible={setApprovedDateModal}
          selected={selected || {}}
        />
      )}
      {moveToExecutorModal && (
        <MoveToExecutor
          isVisible={moveToExecutorModal}
          setVisible={setMoveToExecutorModal}
          selected={selected || {}}
        />
      )}
      {executorModal && (
        <UpdateExecutor
          isVisible={executorModal}
          setVisible={setExecutorModal}
          selected={selected || {}}
        />
      )}
      {deleteModal && (
        <DeleteRequest
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected || {}}
        />
      )}
      {completeModal && (
        <CompleteRequest
          isVisible={completeModal}
          setVisible={setCompleteModal}
          selected={selected || {}}
        />
      )}

      {unitModal && (
        <UpdateBusiness
          isVisible={unitModal}
          setVisible={setUnitModal}
          selected={selected || {}}
        />
      )}

      {detailsModal && (
        <RequestDetails
          isVisible={detailsModal}
          setVisible={setDetailsModal}
          title="Request Details"
          id={selected?._id}
        />
      )}
      {approveModal && (
        <ApproveRequest
          isVisible={approveModal}
          setVisible={setApproveModal}
          selected={selected || {}}
        />
      )}
    </Drawer>
  );
}
